import {OverlayAnimationRestDto} from "@/api/pharma-cms-content-block/models";
import {CardinalDirectionEnum} from "@/api/enums/cardinal-direction-enum";
import {OverlayAnimationTypeEnum} from "@/api/enums/overlay-animation-type-enum";
import {OverlayTriggerTypeEnum} from "@/api/enums/overlay-trigger-type-enum";

export class OverlayAnimationRestDtoModel implements OverlayAnimationRestDto {
    animation_code: OverlayAnimationTypeEnum;
    slide_direction_code?: CardinalDirectionEnum | null;
    animation_trigger_code: OverlayTriggerTypeEnum;
    animation_duration_in_ms: number;

    constructor(animation_code: OverlayAnimationTypeEnum, animation_trigger_code: OverlayTriggerTypeEnum, animation_duration_in_ms: number) {
        this.animation_code = animation_code;
        this.animation_trigger_code = animation_trigger_code;
        this.animation_duration_in_ms = animation_duration_in_ms;
    }

    static createWithDefaults(): OverlayAnimationRestDtoModel {
        return new this(OverlayAnimationTypeEnum.FADE, OverlayTriggerTypeEnum.HOVER, 300);
    }

    /**
     * An animation with nothing filled in yet. The API requires all three fields, so this is not a
     * valid animation to send; it exists to give the editor something to bind to while the user has
     * not decided whether there should be an animation at all.
     */
    static createEmpty(): OverlayAnimationRestDtoModel {
        const empty: OverlayAnimationRestDtoModel = new this(
            null as unknown as OverlayAnimationTypeEnum,
            null as unknown as OverlayTriggerTypeEnum,
            null as unknown as number,
        );
        empty.slide_direction_code = null;

        return empty;
    }

    static cloneFrom(source: OverlayAnimationRestDto): OverlayAnimationRestDtoModel {
        const clone: OverlayAnimationRestDtoModel = new this(
            source.animation_code,
            source.animation_trigger_code,
            source.animation_duration_in_ms,
        );
        clone.slide_direction_code = source.slide_direction_code ?? null;

        return clone;
    }
}
